<template>
    <BCard>
      <ValidationObserver ref="form" #default="{invalid}">
          <BForm @submit.prevent="onSubmit">
              <BRow>
                <TextInputValidated vsName="Name" :vsModel.sync="discount.name" vsMd="6" vsRequired vsRules="required" />
                <VSelectValidated vsName="Discount type" :vsReduce="type => type.value" :vsOptions="discountTypes" vsLabel="name" :vsModel.sync="discount.type" vsMd="6" vsRequired vsRules="required" />
                <VSelectValidated vsName="Apply discount to" :vsReduce="item => item.value" @vsOnInput="onSelectedItemType" :vsOptions="discountItemTypes" vsLabel="name" :vsModel.sync="discount.item_type" vsMd="6" vsRequired vsRules="required" />
                <VSelectValidated :vsName="itemLabel" :vsOptions="items" vsLabel="name" :vsReduce="item => item.id " :vsModel.sync="discount.item_id" vsMd="6" v-if="items" />
                <DatepickerValidated vsName="Start date" :vsModel.sync="discount.start_date" vsMd="6" vsRequired vsRules="required"/>
                <DatepickerValidated vsName="End date" :vsModel.sync="discount.end_date" vsMd="6" />
                <NumberInputValidated vsName="Value" :vsModel.sync="discount.value" vsMd="6" vsRequired vsRules="required" />
              </BRow>

              <!-- Action Buttons -->
              <BButton variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
              <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'discounts' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
          </BForm>
      </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BRow, BForm, BButton } from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import { ValidationObserver } from 'vee-validate';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import popups from '@/hooks/popups';
import axios from '@axios';

export default {
    components: { BCard, BRow, BForm, BButton, ValidationObserver, TextInputValidated, NumberInputValidated, VSelectValidated, CheckboxValidated, DatepickerValidated },
    setup() {
        // Variables
        const { errorToast } = popups()
        const items = ref(null)
        const itemLabel = ref("Selecciona un elemento")
        const discount = ref({
            'name': '',
            'type': null,
            'value': '',
            'start_date': '',
            'end_date': '',
            'item_type': null,
            'item_id': null,
            'status': false
        })

        const discountTypes = [
            { name: 'Porcentaje', value: 'percentage' },
            { name: 'Importe', value: 'amount' }
        ]

        const discountItemTypes = [
            { name: 'Todos', value: 'all' },
            { name: 'Cursos', value: 'courses' },
            { name: 'Productos', value: 'products' },
            { name: 'Curso', value: 'course' },
            { name: 'Producto', value: 'product' },
            { name: 'Sección', value: 'section' },
            { name: 'Familia', value: 'family' }
        ]

        // Métodos
        /**
         * Validar y enviar formulario
         */
        const onSubmit = function(){
          this.$refs.form.validate().then(success => {
              if(success) {
                  axios.post('discounts', JSON.parse(JSON.stringify(discount.value))).then(response => {
                    this.$router.push({ name: 'discounts' })
                }).catch(error => {
                    errorToast('Can\'t add discount')
                })
              }
          })
        }

        /**
         * Cargar datos en función del la opción seleccionada
         */
        const onSelectedItemType = function(event){
            if(event == "course"){
                itemLabel.value = "Select a course"
                axios.get('courses').then(response => {
                    items.value = response.data.courses
                })
                return
            }
            if(event == "product"){
                itemLabel.value = "Select a product"
                axios.get('products').then(response => {
                    items.value = response.data.products
                })
                return
            }
            if(event == "section"){
                itemLabel.value = "Select a course section"
                axios.get('sections').then(response => {
                    items.value = response.data.sections
                })
                return
            }
            if(event == "family"){
                itemLabel.value = "Select a product family"
                axios.get('families').then(response => {
                    items.value = response.data.families
                })
                return
            }
            items.value = null
        }

        return {
            onSelectedItemType,
            discountItemTypes,
            discountTypes,
            itemLabel,
            onSubmit,
            discount,
            items
        }
    }
}
</script>
